// src/components/Pricing/index.js

import React from 'react'
import {
  getClientToken,
  getPlans,
  getSubscription,
  getCustomer,
  updateSubscription,
  createSubscription,
  openPaymentsModal,
} from 'actions/paymentsManager'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import DropIn from '../DropIn/index.js'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepButton from '@material-ui/core/StepButton'
import Button from 'components/theme/Button'
import Dialog from '@material-ui/core/Dialog'
import Paper from '@material-ui/core/Paper'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import { userSignOut } from 'actions/auth'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import { withStyles } from '@material-ui/core/styles'
import { startCase, last } from 'lodash'
import Address from './Address'
import { StepIcon, StepLabel, LinearProgress } from '@material-ui/core'
import { Done } from '@material-ui/icons'
import { list, read } from 'actions/data'
import OveragesApiUrl from 'utils/OveragesApiUrl'
import numberWithCommas from 'utils/numberWithCommas'
import { stepperGoTo } from 'actions/view'
import Tooltip from 'components/theme/HelpTooltip.js'
import {
  BillingCycleButton,
  // additionalUsageCalculator,
} from 'components/AdditionalUsage'
// import classNames from 'classnames'

const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')

function getSteps() {
  return [
    'Enter your payment information',
    'Enter your business address',
    'Choose A Plan',
    'Subscription Details',
  ]
}

const styles = theme => ({
  dialogContentRoot: {
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      overflowX: 'hidden',
    },
  },
  errorColor: {
    color: 'red',
  },
  alternativeLabel: {
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  usageCostsHeader: {
    margin: '0 0 4px 0',
    fontSize: 24,
    // [theme.breakpoints.down('sm')]: {
    //   fontSize: '0.9em',
    // },
  },
  subscriptionDetailsContainer: {
    border: '1px solid #ccc',
    borderRadius: 30,
    paddingTop: 10,
    [theme.breakpoints.down('sm')]: {
      border: 'none',
    },
  },
  subscriptionDetailsGridItem: {
    marginTop: 20,
    // borderRight: '1px solid #ccc',
    [theme.breakpoints.down('sm')]: {
      border: '1px solid #ccc',
      borderRadius: 30,
    },
  },
  subscriptionDetail: {
    padding: 10,
    textAlign: 'left',
    borderTop: '1px solid #ccc',
    borderRight: '1px solid #ccc',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      borderRight: 'none',
    },
  },
  transactionDetail: {
    padding: 10,
    textAlign: 'left',
    borderTop: '1px solid #ccc',
    position: 'relative',
  },
  detailValue: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(0, -50%)',
  },
  subscriptionDetailHeader: {
    textAlign: 'center',
    fontWeight: 'bold',
  },
})

export const bullets = (overages, planID) => {
  if (overages && planID) {
    return (
      <>
        <div>
          <Done
            style={{
              color: '#15b940',
              verticalAlign: 'middle',
              marginRight: 5,
            }}
          />
          {numberWithCommas(overages[planID].user_limit)}{' '}
          {overages[planID].user_unit}
        </div>
        <div>
          <Done
            style={{
              color: '#15b940',
              verticalAlign: 'middle',
              marginRight: 5,
            }}
          />
          {numberWithCommas(overages[planID].email_limit)}{' '}
          {overages[planID].email_unit}
        </div>
        <div>
          <Done
            style={{
              color: '#15b940',
              verticalAlign: 'middle',
              marginRight: 5,
            }}
          />
          {numberWithCommas(overages[planID].text_limit)}{' '}
          {overages[planID].text_unit}
        </div>
        <div>
          <Done
            style={{
              color: '#15b940',
              verticalAlign: 'middle',
              marginRight: 5,
            }}
          />
          {numberWithCommas(overages[planID].voice_limit)}{' '}
          {overages[planID].voice_unit}
        </div>
        <div>
          <Done
            style={{
              color: '#15b940',
              verticalAlign: 'middle',
              marginRight: 5,
            }}
          />
          {numberWithCommas(overages[planID].phone_number_limit)}{' '}
          {overages[planID].phone_unit}
        </div>
        <div>
          <Done
            style={{
              color: '#15b940',
              verticalAlign: 'middle',
              marginRight: 5,
            }}
          />
          {numberWithCommas(overages[planID].storage_limit)}{' '}
          {overages[planID].storage_unit}
        </div>
      </>
    )
  }

  return null
}

class PricingManager extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      instance: undefined,
      paymentMethodRequestable: false,
      activeStep: 0,
      pricingModalOpen: false,
      cycle: 0,
      disabledPricingStep: false,
    }
  }

  componentDidMount() {
    this.props.getClientToken()
    this.props.getPlans()
    this.props.getCustomer()
    this.props.list('overages', 'plan_id', `${OveragesApiUrl}/overages`)
  }

  componentWillUnmount() {
    this.handleReset()
  }

  totalSteps = () => getSteps().length

  handleNext = () => {
    let activeStep

    if (!this.isLastStep()) {
      activeStep = this.props.activeStep + 1
    }
    this.props.stepperGoTo(activeStep, 'pricing')
  }

  signOut = () => {
    jwtToken
      ? window.ReactNativeWebView &&
        window.ReactNativeWebView.postMessage('signout')
      : this.props.userSignOut()
  }

  handleBack = () => {
    this.props.stepperGoTo(this.props.activeStep - 1, 'pricing')
  }

  handleStep = step => () => {
    this.props.stepperGoTo(step, 'pricing')
  }

  handleReset = () => {
    this.props.stepperGoTo(0, 'pricing')
  }

  isLastStep() {
    return this.props.activeStep === this.totalSteps() - 1
  }

  requestPayment = () => {
    const { instance, paymentMethodRequestable } = this.state
    const { getCustomer, subscription, updateSubscription, customer } =
      this.props

    // getCustomer().then(() => {
    console.log('paymentMethodRequestable:', paymentMethodRequestable)
    if (instance && paymentMethodRequestable) {
      instance.requestPaymentMethod(function (
        requestPaymentMethodErr,
        payload,
      ) {
        // Submit payload.nonce to your server
        // console.log('timeout')
        // console.log('payload', payload)
        console.log(
          'find',
          customer.creditCards.find(
            card => card.last4 === payload.details.lastFour,
          ),
        )

        console.log('hits if')

        setTimeout(function () {
          if (!requestPaymentMethodErr) {
            console.log('here')
            console.log('subscription:', subscription)
            if (
              subscription &&
              payload &&
              payload.details &&
              payload.details.lastFour &&
              customer &&
              customer.creditCards &&
              customer.creditCards.find(
                card => card.last4 === payload.details.lastFour,
              )
            ) {
              const token = customer.creditCards.find(
                card => card.last4 === payload.details.lastFour,
              ).token

              updateSubscription(
                subscription.planId,
                token,
                subscription.id,
              ).then(() => getCustomer())
            } else {
              getCustomer()
            }
          } else console.log(requestPaymentMethodErr)
        }, 3000)
      })
    }
    // })
  }

  onNoPaymentMethodRequestable(e) {
    console.log('onNoPaymentMethodRequestable', e)
    this.setState({
      ...this.state,
      paymentMethodRequestable: false,
    })
  }
  onPaymentMethodRequestable(e) {
    console.log('onPaymentMethodRequestable', e, this.state)
    this.setState({
      ...this.state,
      customerPaymentMethod: undefined,
      paymentMethodRequestable: true,
    })
  }
  onInstance(instance) {
    this.setState({
      ...this.state,
      instance,
    })
    // const that = this;
    // e.requestPaymentMethod(function (requestPaymentMethodErr, payload) {
    //   // Submit payload.nonce to your server
    //   console.log(payload, that.setState)
    // });
  }
  togglePriceButton() {
    const { disabledPricingStep } = this.state

    this.setState({
      disabledPricingStep: !disabledPricingStep,
    })
  }

  handleSubscriptionAndFetch = async (...args) => {
    const urlencoded = new URLSearchParams()
    urlencoded.append('phone', this.props.idTokenPayload?.phone_number)
    urlencoded.append('email', this.props.idTokenPayload?.email)

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: urlencoded,
      redirect: 'follow',
    }

    try {
      // Create subscription
      await this.props.createSubscription(...args)

      // Fetch data
      const response = await fetch(
        'https://leads.vastreach.com/customform/cipost/339fd8b4-dede-4cbb-8025-59569da4a401',
        requestOptions,
      )
      const result = await response.text()
      console.log(result)

      // Get customer and toggle price button
      await this.props.getCustomer()
      setTimeout(() => {
        this.togglePriceButton()
      }, 500)
    } catch (error) {
      console.error('Error:', error)
      // Handle errors appropriately
    }
  }

  render() {
    const {
      client_token,
      plans,
      customer,
      getCustomer,
      loading_customer,
      show_payments_modal,
      fullScreen,
      openPaymentsModal,
      subscription,
      activeStep,
      classes,
    } = this.props
    const { paymentMethodRequestable, instance, disabledPricingStep } =
      this.state
    const steps = getSteps()
    const isLastStep = this.isLastStep()
    const customerPaymentMethod = customer
      ? customer.paymentMethods
        ? customer.paymentMethods.find(pm => pm.default)
        : undefined
      : undefined

    const anyMissingRequiredAddressFields =
      !customer ||
      !customer.addresses ||
      !last(customer.addresses) ||
      !last(customer.addresses).streetAddress ||
      !last(customer.addresses).locality ||
      !last(customer.addresses).region ||
      !last(customer.addresses).postalCode

    // console.log(
    //   'anyMissingRequiredAddressFields:',
    //   anyMissingRequiredAddressFields,
    // )

    // if (customer) {
    //   console.log('customer')
    //   if (customer.addresses) {
    //     console.log(customer.addresses)
    //     if (last(customer.addresses)) {
    //       console.log(last(customer.addresses))
    //       if (last(customer.addresses).streetAddress) {
    //         console.log(last(customer.addresses).streetAddress)
    //       }
    //     }
    //   }
    // }

    const PricingSlots =
      Array.isArray(plans) &&
      customer &&
      this.props.overages &&
      Object.values(this.props.overages).length
        ? plans
            .sort((a, b) => parseInt(a.price) - parseInt(b.price))
            .map(plan => {
              return (
                <Grid key={plan.id} item xs="12" md="12" sm="12" lg="4">
                  <Paper
                    key={plan.id}
                    style={{
                      textAlign: 'center',
                      borderRadius: 22,
                      margin: 8,
                      padding: 20,
                      height: 'calc(100% - 16px)',
                      position: 'relative',
                    }}
                  >
                    <h2 style={{ margin: 0 }}>{plan.name}</h2>
                    <h2 style={{ margin: 10 }}>{`$${plan.price}/mo`}</h2>
                    <p style={{ margin: 22 }}>{plan.description}</p>
                    <div>
                      <Button
                        variant="contained"
                        color="secondary"
                        disabled={
                          (subscription && plan.id === subscription.planId) ||
                          !customerPaymentMethod ||
                          disabledPricingStep
                        }
                        style={{
                          fontSize: '12px',
                          width: '100%',
                        }}
                        onClick={() => {
                          if (!customerPaymentMethod) return 0
                          this.togglePriceButton()
                          const args = [
                            plan.id,
                            customerPaymentMethod.token,
                            subscription ? subscription.id : null,
                          ]
                          return subscription
                            ? this.props
                                .updateSubscription(...args)
                                .then(() => {
                                  getCustomer().then(() => {
                                    setTimeout(() => {
                                      this.togglePriceButton()
                                    }, 500)
                                  })
                                })
                            : this.handleSubscriptionAndFetch(...args)
                        }}
                      >
                        {subscription
                          ? plan.id === subscription.planId
                            ? `Your subscription to this plan is: ${startCase(
                                subscription.status,
                              )}`
                            : 'Switch to this plan'
                          : 'Subscribe to this plan'}
                      </Button>
                    </div>
                    {plan.trialPeriod === true ? (
                      <p>
                        <strong>
                          Try it free for {plan.trialDuration}{' '}
                          {plan.trialDurationUnit}
                          {plan.trialDuration > 1 ? 's' : null}
                        </strong>
                      </p>
                    ) : null}
                    <p
                      style={{
                        margin: 22,
                        fontWeight: 'bold',
                        // minHeight: '390px',
                      }}
                    >
                      {subscription ? (
                        plan.id === subscription.planId ? (
                          <span>
                            You are currently subscribed to this plan.
                          </span>
                        ) : null
                      ) : null}
                    </p>
                    <h4>Plan Includes</h4>
                    <div style={{ textAlign: 'left' }}>
                      {bullets(this.props.overages, plan.id)}
                    </div>
                  </Paper>
                </Grid>
              )
            })
        : []

    const stepContent = [
      <div
        style={{ padding: 10 }}
        className="containter-fluid text-center pricing-intro"
      >
        {client_token && client_token !== 'notoken' ? (
          <div>
            <p>
              Enter your payment information and click <strong>save</strong> to
              continue to the next step.
            </p>
            <DropIn
              style={{ margin: 25 }}
              options={{
                authorization: `${client_token}`,
              }}
              onPaymentMethodRequestable={e =>
                this.onPaymentMethodRequestable(e)
              }
              onInstance={instance => this.onInstance(instance)}
            />
            {paymentMethodRequestable && instance ? (
              <Button
                variant="contained"
                style={{
                  backgroundColor: '#219653',
                  color: 'white',
                }}
                onClick={this.requestPayment}
              >
                Save your payment method
              </Button>
            ) : null}
          </div>
        ) : null}
      </div>,

      <Address
        anyMissingRequiredAddressFields={anyMissingRequiredAddressFields}
      />,

      <div>
        <p>
          With Vast Reach no matter what plan you choose you won't have to
          sacrifice any features. Every plan has every feature!{' '}
          <strong>Choose a plan</strong> based on what your organization needs.
          If your needs vary month to month have no fear our additional usage
          pricing is very fair and won't break the bank. See below for pricing.
        </p>
        {disabledPricingStep ? <LinearProgress /> : null}
        <Grid container spacing={16}>
          {PricingSlots}
        </Grid>
        {/* <div style={{ marginTop: 16 }}>
          <span role="img" aria-label="smile">
            😄
          </span>{' '}
          <em>See below for additional usage pricing.</em>
        </div> */}
        <div style={{ margin: '24px 0' }}>
          <h2 className={this.props.classes.usageCostsHeader}>
            ADDITIONAL USAGE COSTS
          </h2>
          <em>
            If you exceed usage limits, you will be charged according to the
            chart below.
          </em>
        </div>
        {Array.isArray(plans) &&
          customer &&
          this.props.overages &&
          Object.values(this.props.overages).length && (
            <Grid container spacing={16}>
              {plans
                .sort((a, b) => parseInt(a.price) - parseInt(b.price))
                .map(plan => {
                  return (
                    <Grid
                      key={`overageTile${plan.id}`}
                      item
                      xs="12"
                      md="12"
                      sm="12"
                      lg="4"
                    >
                      <Paper
                        style={{
                          textAlign: 'center',
                          borderRadius: 22,
                          margin: 8,
                          paddingBottom: 6,
                          position: 'relative',
                        }}
                      >
                        <h2 style={{ margin: 0, padding: '18px 0' }}>
                          {plan.name}
                        </h2>
                        <table
                          style={{
                            textAlign: 'left',
                            borderCollapse: 'collapse',
                            width: '100%',
                          }}
                        >
                          <thead>
                            <tr>
                              <th
                                style={{
                                  fontWeight: 600,
                                  paddingLeft: 15,
                                  borderBottom: '1px solid gray',
                                }}
                              >
                                Included
                              </th>
                              <th
                                style={{
                                  fontWeight: 600,
                                  paddingLeft: 7,
                                  borderBottom: '1px solid gray',
                                }}
                              >
                                Additional costs
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  fontWeight: 500,
                                  paddingLeft: 15,
                                  borderBottom: '1px solid gray',
                                }}
                              >
                                {numberWithCommas(
                                  this.props.overages[plan.id].user_limit,
                                )}{' '}
                                {this.props.overages[plan.id].user_unit}
                              </td>
                              <td
                                style={{
                                  borderBottom: '1px solid gray',
                                  padding: '1px 15px 1px 7px',
                                }}
                              >
                                $
                                {this.props.overages[plan.id].user_overage_cost}{' '}
                                per additional{' '}
                                {this.props.overages[plan.id].user_unit.slice(
                                  0,
                                  -1,
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  fontWeight: 500,
                                  paddingLeft: 15,
                                  borderBottom: '1px solid gray',
                                }}
                              >
                                {numberWithCommas(
                                  this.props.overages[plan.id].email_limit,
                                )}{' '}
                                {this.props.overages[plan.id].email_unit}
                              </td>
                              <td
                                style={{
                                  borderBottom: '1px solid gray',
                                  padding: '1px 15px 1px 7px',
                                }}
                              >
                                $
                                {
                                  this.props.overages[plan.id]
                                    .email_overage_cost
                                }{' '}
                                per additional{' '}
                                {this.props.overages[plan.id].email_unit.slice(
                                  0,
                                  -1,
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  fontWeight: 500,
                                  paddingLeft: 15,
                                  borderBottom: '1px solid gray',
                                }}
                              >
                                {numberWithCommas(
                                  this.props.overages[plan.id].text_limit,
                                )}{' '}
                                {this.props.overages[plan.id].text_unit}
                              </td>
                              <td
                                style={{
                                  borderBottom: '1px solid gray',
                                  padding: '1px 15px 1px 7px',
                                }}
                              >
                                $
                                {this.props.overages[plan.id].text_overage_cost}{' '}
                                per additional{' '}
                                {this.props.overages[plan.id].text_unit.slice(
                                  0,
                                  -1,
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  fontWeight: 500,
                                  paddingLeft: 15,
                                  borderBottom: '1px solid gray',
                                }}
                              >
                                {numberWithCommas(
                                  this.props.overages[plan.id].voice_limit,
                                )}{' '}
                                {this.props.overages[plan.id].voice_unit}
                              </td>
                              <td
                                style={{
                                  borderBottom: '1px solid gray',
                                  padding: '1px 15px 1px 7px',
                                }}
                              >
                                $
                                {
                                  this.props.overages[plan.id]
                                    .voice_overage_cost
                                }{' '}
                                per additional{' '}
                                {this.props.overages[plan.id].voice_unit.slice(
                                  0,
                                  -1,
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  fontWeight: 500,
                                  paddingLeft: 15,
                                  borderBottom: '1px solid gray',
                                }}
                              >
                                {numberWithCommas(
                                  this.props.overages[plan.id]
                                    .phone_number_limit,
                                )}{' '}
                                {this.props.overages[plan.id].phone_unit}
                              </td>
                              <td
                                style={{
                                  borderBottom: '1px solid gray',
                                  padding: '1px 15px 1px 7px',
                                }}
                              >
                                $
                                {
                                  this.props.overages[plan.id]
                                    .phone_number_overage_cost
                                }{' '}
                                per additional{' '}
                                {this.props.overages[plan.id].phone_unit.slice(
                                  0,
                                  -1,
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  fontWeight: 500,
                                  paddingLeft: 15,
                                }}
                              >
                                {numberWithCommas(
                                  this.props.overages[plan.id].storage_limit,
                                )}{' '}
                                {this.props.overages[plan.id].storage_unit}
                              </td>
                              <td style={{ padding: '1px 15px 1px 7px' }}>
                                $
                                {
                                  this.props.overages[plan.id]
                                    .storage_overage_cost
                                }{' '}
                                per additional{' '}
                                {this.props.overages[
                                  plan.id
                                ].storage_unit.slice(0, -1)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </Paper>
                    </Grid>
                  )
                })}
            </Grid>
          )}
      </div>,

      <div>
        {subscription ? (
          <>
            <div className={classes.subscriptionDetailsContainer}>
              <BillingCycleButton
                cycle={this.state.cycle}
                setCycle={idx => this.setState({ cycle: idx })}
                subscription={subscription}
              />
              <div>
                <em>
                  Updated on{' '}
                  {this.state.cycle === 0
                    ? subscription?.updatedAt?.slice?.(0, 10)
                    : subscription?.transactions?.[
                        this.state.cycle
                      ]?.updatedAt?.slice?.(0, 10)}
                </em>
              </div>
              <Grid container>
                <Grid
                  className={classes.subscriptionDetailsGridItem}
                  item
                  sm={12}
                  md={6}
                >
                  <div className={classes.subscriptionDetailHeader}>
                    SUBSCRIPTION DETAILS
                  </div>
                  <div className={classes.subscriptionDetail}>
                    <strong>{`${
                      this.state.cycle === 0 ? 'Next ' : ''
                    }Bill Date: `}</strong>
                    <span className={classes.detailValue}>
                      {this.state.cycle === 0
                        ? subscription.nextBillingDate
                        : subscription.transactions?.[this.state.cycle - 1]
                            ?.subscription?.billingPeriodStartDate}
                    </span>
                  </div>
                  <div className={classes.subscriptionDetail}>
                    <strong>Paid Through Date: </strong>
                    <span className={classes.detailValue}>
                      {this.state.cycle === 0
                        ? subscription.paidThroughDate
                        : subscription.transactions?.[this.state.cycle]
                            ?.subscription?.billingPeriodEndDate}
                    </span>
                  </div>
                  <div className={classes.subscriptionDetail}>
                    <strong>Subscriber Since: </strong>
                    <span className={classes.detailValue}>
                      {subscription.createdAt?.slice?.(0, 10)}
                    </span>
                  </div>
                  <div className={classes.subscriptionDetail}>
                    <strong>Status: </strong>
                    <span
                      className={classes.detailValue}
                      style={
                        (this.state.cycle === 0 &&
                          subscription.status === 'Active') ||
                        subscription.transactions?.[this.state.cycle]
                          ?.status === 'settled'
                          ? { color: 'green' }
                          : null
                      }
                    >
                      {this.state.cycle === 0
                        ? subscription.status
                        : subscription.transactions?.[this.state.cycle]?.status}
                    </span>
                  </div>
                </Grid>
                <Grid
                  className={classes.subscriptionDetailsGridItem}
                  item
                  sm={12}
                  md={6}
                >
                  <div className={classes.subscriptionDetailHeader}>
                    TRANSACTION DETAILS
                  </div>
                  <div className={classes.transactionDetail}>
                    <strong>{`${
                      this.state.cycle === 0 ? 'Current ' : ''
                    }Balance: `}</strong>
                    <span className={classes.detailValue}>
                      ${this.state.cycle === 0 ? subscription.balance : '0.00'}
                    </span>
                  </div>
                  {/* <div className={classes.transactionDetail}>
									<strong>Next Bill Amount: </strong>
									<span className={classes.detailValue}>
										{subscription.nextBillAmount}
									</span>
								</div> */}
                  <div className={classes.transactionDetail}>
                    <strong>Additional Usage Fees: </strong>
                    <span className={classes.detailValue}>
                      $
                      {this.state.cycle === 0
                        ? subscription?.addOns.find(
                            addOn => addOn.id === 'overages',
                          )?.amount || '0.00'
                        : subscription.transactions?.[
                            this.state.cycle
                          ]?.addOns.find(addOn => addOn.id === 'overages')
                            ?.amount || '0.00'}
                      {this.state.cycle === 0 && '*'}
                    </span>
                  </div>
                  <div className={classes.transactionDetail}>
                    <strong>Taxes: </strong>
                    <span className={classes.detailValue}>
                      $
                      {this.state.cycle === 0
                        ? subscription?.addOns.find(
                            addOn => addOn.id === 'taxes',
                          )?.amount || '0.00'
                        : subscription.transactions?.[
                            this.state.cycle
                          ]?.addOns.find(addOn => addOn.id === 'taxes')
                            ?.amount || '0.00'}
                      {this.state.cycle === 0 && '*'}
                    </span>
                  </div>
                  <div className={classes.transactionDetail}>
                    <strong>{`Total ${
                      this.state.cycle === 0 ? 'Due' : 'Paid'
                    }: `}</strong>
                    <span
                      style={{ color: 'green' }}
                      className={classes.detailValue}
                    >
                      $
                      {this.state.cycle === 0
                        ? subscription.nextBillAmount
                        : subscription.transactions?.[this.state.cycle]?.amount}
                      {this.state.cycle === 0 && '*'}
                    </span>
                  </div>
                </Grid>
              </Grid>
            </div>
            {this.state.cycle === 0 && (
              <em>
                *Taxes and overages are calculated near the end of the billing
                cycle. Actual amounts may vary once charged.
              </em>
            )}
          </>
        ) : (
          <div>
            <em>Choose a plan in step 2</em>
          </div>
        )}
      </div>,
    ]

    return (
      <>
        <Dialog
          fullScreen={fullScreen}
          open={
            // these conditions will need to change once onboarding is finalized
            (customer && !subscription) ||
            (customer && !customerPaymentMethod) ||
            (customer && anyMissingRequiredAddressFields) ||
            show_payments_modal
          }
          aria-labelledby="responsive-dialog-title"
          style={{ borderRadius: 22 }}
          maxWidth="xl"
          fullWidth
          PaperProps={{
            style: {
              borderRadius: 22,
              textAlign: 'center',
              padding: 20,
            },
          }}
          onClose={() =>
            !loading_customer && subscription ? openPaymentsModal(false) : null
          }
        >
          <DialogTitle
            id="responsive-dialog-title"
            style={{ textAlign: 'left' }}
          >
            <div style={{ position: 'relative' }}>
              <Hidden smDown>
                <h2
                  style={{
                    margin: 0,
                    position: 'absolute',
                    left: '50%',
                    transform: 'translate(-50%, 0)',
                    fontSize: 24,
                  }}
                >
                  MANAGE YOUR SUBSCRIPTION{' '}
                  <Tooltip>
                    <span>
                      You can manage your subscriptions options from here using
                      the stepper below. Step one (Enter your payment
                      information) allows you to set up your payment options.
                      Step 2 (Enter your business address) is where you would
                      enter your business address for billing. Step 3 (Choose A
                      Plan) is where you would choose your{' '}
                      <strong>Vast Reach</strong> plan based on your business
                      needs with additional cost break down below that. Step 4
                      (Subscription Details) will show you your subscription
                      details such as your current balance, your next billing
                      due date, taxes, etc..
                    </span>
                  </Tooltip>
                </h2>
              </Hidden>
              <Hidden mdUp>
                <span
                  style={{
                    position: 'absolute',
                    top: '-15px',
                    left: '-15px',
                    fontSize: '0.9em',
                  }}
                >
                  MANAGE YOUR SUBSCRIPTION{' '}
                  <Tooltip>
                    <span>
                      You can manage your subscriptions options from here using
                      the stepper below. Step one (Enter your payment
                      information) allows you to set up your payment options.
                      Step 2 (Enter your business address) is where you would
                      enter your business address for billing. Step 3 (Choose A
                      Plan) is where you would choose your{' '}
                      <strong>Vast Reach</strong> plan based on your business
                      needs with additional cost break down below that. Step 4
                      (Subscription Details) will show you your subscription
                      details such as your current balance, your next billing
                      due date, taxes, etc..
                    </span>
                  </Tooltip>
                </span>
              </Hidden>
              <span
                onClick={() => this.signOut()}
                style={{
                  fontSize: 12,
                  padding: 20,
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  float: 'right',
                }}
              >
                sign out
              </span>
              <span
                onClick={() => openPaymentsModal(false)}
                style={{
                  fontSize: 12,
                  padding: 20,
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  float: 'right',
                }}
              >
                Close
              </span>
            </div>
          </DialogTitle>
          <DialogContent
            classes={{ root: this.props.classes.dialogContentRoot }}
          >
            {jwtToken ? (
              <p>
                You are seeing this message because the account owner has not
                finished configuring your subscription or your trial period /
                payment method has expired. To manage your subscription
                settings, please contact the account owner. If you are the
                account owner, you cannot manage subscription settings in the
                mobile app.
              </p>
            ) : (
              <div>
                {' '}
                <Stepper
                  classes={{
                    alternativeLabel: this.props.classes.alternativeLabel,
                  }}
                  nonLinear
                  activeStep={activeStep}
                  alternativeLabel
                >
                  {steps.map((label, index) => {
                    const disabled =
                      (index > 2 && !subscription) ||
                      (index > 0 && !customerPaymentMethod)

                    return (
                      <Step key={label}>
                        <StepButton
                          icon={
                            <StepIcon
                              // classes={
                              //   anyMissingRequiredAddressFields
                              //     ? { root: this.props.classes.errorColor }
                              //     : null
                              // }
                              icon={
                                <div
                                  style={{
                                    backgroundColor:
                                      anyMissingRequiredAddressFields &&
                                      index === 1
                                        ? 'red'
                                        : disabled
                                        ? 'gray'
                                        : '#026fd9',
                                    color: '#fff',
                                    height: 26,
                                    width: 34,
                                    borderRadius: '50%',
                                    paddingTop: 8,
                                  }}
                                >
                                  {index + 1}
                                </div>
                              }
                            />
                          }
                          onClick={this.handleStep(index)}
                          disabled={disabled}
                          completed={
                            (index === 0 && customerPaymentMethod) ||
                            (index === 1 && !anyMissingRequiredAddressFields) ||
                            (index === 2 && subscription) ||
                            (index === 3 && subscription)
                              ? true
                              : false
                          }
                        >
                          <StepLabel
                            classes={
                              anyMissingRequiredAddressFields
                                ? {
                                    alternativeLabel:
                                      this.props.classes.errorColor,
                                  }
                                : null
                            }
                          >
                            {label}
                          </StepLabel>
                        </StepButton>
                      </Step>
                    )
                  })}
                </Stepper>
                <div className="pricing-intro">{stepContent[activeStep]}</div>
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button disabled={activeStep === 0} onClick={this.handleBack}>
              {activeStep !== 0 ? `Back to ${steps[activeStep - 1]}` : ''}
            </Button>

            {!jwtToken &&
            ((!isLastStep && subscription) ||
              (!isLastStep && customerPaymentMethod)) ? (
              <Button
                variant="contained"
                color="secondary"
                onClick={this.handleNext}
              >
                Next
              </Button>
            ) : null}
          </DialogActions>
        </Dialog>
        <Dialog open={false}>
          <DialogContent>
            By clicking subscribing to this plan, you accept the terms of
            service, which can be found here{' '}
            <a href="https://vastreach.com/TermsOfService">here</a>.
          </DialogContent>
          <DialogActions>
            <Button onClick={() => console.log('click')}>Close</Button>
            <Button onClick={() => console.log('click')}>Accept</Button>
          </DialogActions>
        </Dialog>
      </>
    )
  }
}

export default connect(
  (state, { match }) => ({
    client_token: state.paymentsManager.client_token,
    plans: state.paymentsManager.plans,
    instance: null,
    subscription: state.paymentsManager.subscription,
    customer: state.paymentsManager.customer,
    loading_customer: state.paymentsManager.loading_customer,
    show_payments_modal: state.paymentsManager.show_payments_modal,
    overages: state.data.overages || {},
    activeStep: state.view.stepper.pricing,
    plansByID: state.paymentsManager?.plans?.reduce?.((acc, plan) => {
      acc[plan.id] = plan
      return acc
    }, {}),
    idTokenPayload: state.auth?.session?.idToken?.payload,
  }),
  dispatch =>
    bindActionCreators(
      {
        getClientToken,
        getPlans,
        userSignOut,
        getSubscription,
        getCustomer,
        updateSubscription,
        createSubscription,
        openPaymentsModal,
        list,
        stepperGoTo,
        read,
      },
      dispatch,
    ),
)(withMobileDialog()(withStyles(styles)(PricingManager)))